if (typeof _debug == 'undefined' || !_debug) {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
    Vue.config.productionTip = false;
}

Vue.config.ignoredElements = ['r-span', 'r-slider', 'r-tabs', 'r-toggle', 'r-shorten', 'r-more-items', 'r-favorite-trigger'];
Vue.use(Vuex);

// main store
var store = new Vuex.Store({
    state: {
    },
    actions: {
    },
    mutations: {
    },
    getters: {
    },
    modules: {
        cart: cartStoreModule,
        products: productsStoreModule
    }
});

// mixins
Vue.mixin({
    methods: {
        thumbnail: function (imageSrc, format) {
            return imageSrc ? Eshop.image(imageSrc, format) : Eshop.options.fullUrl + 'rshop/frontend/img/noimage.png';
        },
        formatPrice: function(price) {
            return Format.price(price);
        },
        plural: function(singular, plural24, plural, count) {
            return Format.plural(singular, plural24, plural, count);
        },
        goToUrl: function(url) {
            window.location.href = url;
        },
        fetch: function(method, url, data, callback, options) {
            if (url && url[0] != '/' && !(url.includes('http://')) && !(url.includes('https://'))) {
                url = Eshop.options.baseUrl + url;
            }

            var timeout = 60000;

            if (typeof options === 'undefined') {
                var options = {};
            }

            if (options.timeout) {
                timeout = options.timeout;
            }

            return $.ajax({
                url: url,
                data: data,
                dataType: 'json',
                type: method,
                error: function(jqXHR, textStatus, errorThrown) {
                    if(textStatus === 'timeout') {
                        //do something. Try again perhaps?
                    }

                    if (options.errorCallback) {
                        options.errorCallback(jqXHR, textStatus, errorThrown);
                    }
                },
                success: function(response) {
                    callback(response);
                }.bind(this),
                timeout: timeout
            });
        }
    }
})

var RshopApp = new Vue({
    store: store,
    data: {
    },
    components: {
        'cart': CartComponent,
        'auto-complete': AutocompleteComponent,
        'cart-auto-complete': CartAutocompleteComponent,
        'product-alternatives': ProductAlternativesComponent,
        'customer-wishlist': CustomerWishlistComponent
    },
    created: function () {
        rEvent.dispatch('App.created');
    },
    mounted: function () {
        rEvent.dispatch('App.mounted');
    },
    methods: {
    },
    computed: {
    }
});
